/**
 * Error codes handled by arangojs.
 *
 * See also {@link https://www.arangodb.com/docs/stable/appendix-error-codes.html | ArangoDB error documentation}.
 *
 * @packageDocumentation
 * @internal
 * @hidden
 */

export const TRANSACTION_NOT_FOUND = 10;
export const ANALYZER_NOT_FOUND = 1202;
export const DOCUMENT_NOT_FOUND = 1202;
export const COLLECTION_NOT_FOUND = 1203;
export const VIEW_NOT_FOUND = 1203;
export const DATABASE_NOT_FOUND = 1228;
export const GRAPH_NOT_FOUND = 1924;
